import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import dynamic from 'next/dynamic';

import Container from '../common/Container';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CloudinaryImage from '../common/CloudinaryImage';
import 'app/components/HireDevelopers/approach.css';

const Slider = dynamic(() => import('react-slick'));

export default function DevProcess({ devprocess }) {
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container>
      <div
        className={
          devprocess?.title && 'lg:mb-[35px] mb-[30px] text-center text-white'
        }
      >
        {devprocess?.title && (
          <h2
            className={`font-[800] xl:text-[55px] md:text-[32px] text-[25px] leading-tight mb-3`}
          >
            {devprocess?.title}
          </h2>
        )}
        {devprocess?.description && (
          <p className="max-w-[1100px] mx-auto lg:text-[20px] text-[16px] font-[400]">
            {devprocess?.description}
          </p>
        )}
      </div>
      <div className="approach_slider">
        <Slider {...settings}>
          {devprocess?.reasonList &&
            devprocess?.reasonList?.map((data, key) => (
              <div
                key={data?.id}
                className="relative border border-[#FFFFFF] rounded-[20px] text-white p-6"
              >
                <span className="absolute right-5 text-[#7E8187] text-[20px] inline-block font-[400]">{`0${key + 1}`}</span>
                {data?.image?.data && (
                  <CloudinaryImage
                    backendImgUrl={data?.image?.data[0]?.attributes?.url}
                    width={'80px'}
                    height={'80px'}
                    className={'w-[80px] mb-2'}
                    alt={data?.image?.data[0]?.attributes?.alternativeText}
                    type="icon"
                  />
                )}
                {data?.headingLink ? (
                  <h6 className="lg:text-[24px] text-[20px] font-[700] mb-2">
                    <Link href={`${data?.headingLink}`}>{data?.title}</Link>
                  </h6>
                ) : (
                  <h6 className="lg:text-[24px] text-[20px] font-[700] mb-2">
                    {data?.title}
                  </h6>
                )}
                {data?.editor && (
                  <ReactMarkdown
                    rehypePlugins={[rehypeRaw]}
                    source={data?.editor}
                    className="text-[16px] font-[400]"
                  >
                    {data?.editor}
                  </ReactMarkdown>
                )}
              </div>
            ))}
        </Slider>
      </div>
    </Container>
  );
}
